import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthTokenGenerationComponent } from './auth-token-generation/auth-token-generation.component';
import { BiometryCreateComponent } from './biometry-create/biometry-create.component';
import { BiometryComponent } from './biometry.component';


const routes: Routes = [
  {
    path: '',
    component: BiometryCreateComponent,
    data: {
      title: 'Biometría',
      id: 'BiometryModule_biometry'
    },
    children: [
      {
        path: '',
        component: BiometryComponent,
        data: {
          title: 'Biometría',
          id: 'BiometryModule_biometry'
        }
      },
      {
        path: "authTokenAuthorization",
        component: AuthTokenGenerationComponent,
        data: {
          title: "Token de Autorización",
          id: 'AuthTokenGenerationModule_authTokenGeneration',
        }
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BiometryRoutingModule { }
